// Figma "cases" > MG, section 55:1752, frames 55:1753 (cover), 55:1816, 55:1789
import type { Case, Img } from "../types"

const own = (n: string, w: number, h: number): Img => {
    const src = `/work/mg/${n}`
    return { id: src, src, w, h, widths: [...[800, 1600].filter((x) => x < w), w] }
}
const MG = own

export const mg: Case = {
    name: "MG",
    theme: {
        page: "#1f0b18",
        gradient: "linear-gradient(180deg, #1f0b18 0%, #3d1226 58.173%, #6b1d26 100%)",
        stops: [
            [31, 11, 24, 0],
            [61, 18, 38, 0.58173],
            [107, 29, 38, 1],
        ],
        fill: "#000000",
        line: "#e94037",
        tone: "dark",
        title: "#ffffff",
        body: "rgba(255, 255, 255, 0.6)",
    },
    modules: [
        {
            type: "grid",
            columns: [
                {
                    w: 220,
                    cells: [
                        {
                            h: 220,
                            tag: { logo: "/work/mg/logo.svg", logoBox: [20, 20, 53, 54], text: "MG CARS\nCAR BRAND\nSINCE 1968\n\n.COM" },
                        },
                        { h: 626 },
                    ],
                },
                {
                    w: 443,
                    cells: [
                        { h: 443, image: MG("1-1", 886, 886), phone: false },
                        {
                            h: 400,
                            grow: true,
                            card: {
                                title: "The new MG",
                                body: "A new MG that keeps its heritage but brings the brand to new heights. A fresh rebrand implemented with a heavy focus on motion and product experience.",
                            },
                        },
                    ],
                },
                {
                    w: 888,
                    cells: [
                        { h: 589, keep: true, image: { id: "/work/mg/c-desktop", src: "/work/mg/c-desktop", w: 1776, h: 1178, widths: [800, 1776] }, clip: { src: "/work/mg/c-desktop" } }, // video: node 55:1780, dark grey-green panel (blank still, fades lighter at the bottom)
                        { h: 254, w: 511, image: MG("1-2", 1022, 508), phone: false },
                    ],
                },
            ],
        },
        {
            type: "grid",
            columns: [
                {
                    w: 888,
                    cells: [
                        { h: 549, keep: true, image: { id: "/work/mg/c-scene3", src: "/work/mg/c-scene3", w: 1776, h: 1098, widths: [800, 1776] }, clip: { src: "/work/mg/c-scene3" } }, // video: node 55:1840, solid black still
                        { h: 294, w: 309, end: true, image: MG("2-1", 618, 588), phone: false },
                    ],
                },
                { w: 666, cells: [{ h: 846, image: MG("2-2", 1332, 1692) }] },
            ],
        },
        {
            type: "grid",
            phoneCenter: true,
            columns: [
                { w: 443, cells: [{ h: 331, image: MG("3-1", 886, 662) }, { h: 512, image: MG("3-2f", 886, 1024), phone: false }] },
                {
                    w: 1111,
                    cells: [
                        { h: 705, fit: true, image: { id: "/work/mg/c-scene1", src: "/work/mg/c-scene1", w: 1920, h: 1218, widths: [800, 1920] }, clip: { src: "/work/mg/c-scene1" } }, // video: node 55:1813, dark burgundy diagonal-gradient still
                        { h: 138 },
                    ],
                },
            ],
        },
    ],
}
